/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlterarLocalizacaoAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  CARD_0 = 'card-0',
  FETCH_0 = 'fetch-0',
  FETCH_ATUAL = 'fetch-atual',
  FIELD_1 = 'field-1',
  FIELD_ATUAL = 'field-atual',
  FIELD_TOAST = 'field-toast',
  FORM_ALTERAR_LOCALIZACAO = 'form-alterar-localizacao',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  PANEL_0 = 'panel-0',
  PANEL_ALTERAR_LOCALIZACAO = 'panel-alterar-localizacao',
  TEXT_1 = 'text-1',
  TEXT_LOCALIZACAO_ATUAL = 'text-localizacao-atual',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AlterarLocalizacaoAliases };
